export default __webpack_public_path__ + "static/screeny-130-gpz-mb-4-f8af26081cd1b33f0e0c6df062a82a9e.jpg";